import FundsForm from 'src/javascripts/components/forms/FundsForm';

export default class FundsEdit {

  constructor() {}

  render() {

    // Call associated form js
    FundsForm();

  }

}